














































import {
  computed,
  defineComponent,
  Ref,
  ref,
  toRefs
} from '@nuxtjs/composition-api'
import { DYNAMIC_FORM_FIELD_PROPS } from '~/constants/dynamic-form'
import { useDynamicForm } from '~/compositions/dynamic-form'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'
import { AuditPackageOptionTypes } from '~/models/audit/package'
import { useFormComponent } from '~/compositions/form-component'
import { useDynamicFormField } from '~/compositions/dynamic-form/field'

export default defineComponent({
  components: { CFormError },
  props: DYNAMIC_FORM_FIELD_PROPS,
  setup(props) {
    const { name, options } = toRefs(props)
    const selectedOptions = ref<string[]>([])
    const { value, error, changeValue } = useDynamicForm(props, {
      onValue: (v: Ref<string[]>) => {
        if (v.value?.length) {
          selectedOptions.value = v.value
        }
      }
    })

    const categoryOptions = computed(() => {
      return options.value.filter(
        o => o.type === AuditPackageOptionTypes.AUDIT_CATEGORY
      )
    })

    const meansOptions = computed(() => {
      return options.value.filter(
        o => o.type === AuditPackageOptionTypes.AUDIT_MEAN
      )
    })

    function handleCheckboxesInput(val: any) {
      changeValue(name.value, val)
    }

    const { getFieldLabel } = useDynamicFormField()

    const { labelClasses } = useFormComponent(false, ref(false), '', false)

    const auditMeansLabel = computed(() => getFieldLabel('audit_means'))
    return {
      value,
      error,
      handleCheckboxesInput,
      selectedOptions,
      categoryOptions,
      meansOptions,
      labelClasses,
      auditMeansLabel
    }
  }
})
